export default function getFilename(response) {
  var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
  let name = decodeURIComponent(
    filenameRegex.exec(response.headers["content-disposition"])[1]
  );
  return name;
}
